import { FILE_EXTENSIONS } from '@vy/files';
import { sanitizeFilename } from '@vy/utils';
import { saveAs } from 'file-saver';

export function buildUsageEventsReportFilename(customerName: string, invoiceName: string, isZip: boolean): string {
  const rawFileName = `${customerName} - ${invoiceName}`;
  const sanitizedFileName = sanitizeFilename(rawFileName);
  const extension = isZip ? FILE_EXTENSIONS.ZIP : FILE_EXTENSIONS.XLSX;
  return `${sanitizedFileName}-usage-events-report.${extension}`;
}

export function saveUsageEventsReport(blob: Blob, customerName: string, invoiceName: string, isZip: boolean): void {
  const filename = buildUsageEventsReportFilename(customerName, invoiceName, isZip);
  saveAs(blob, filename);
}
